import { ERoleAccessIsAny } from '../../enum'

// Create a union type of all possible values from the enum
type IRoleAccessIsAnyLangKey = `${ERoleAccessIsAny}`

export type IRoleAccessIsAnyLang = {
	role_access_is_any: Record<IRoleAccessIsAnyLangKey, string>
}

const langEntries = Object.entries(ERoleAccessIsAny).map(
	([key, value]) => [value, `role_access_is_any.${value}`]
)

const langObj: Record<IRoleAccessIsAnyLangKey, string> = Object.fromEntries(langEntries)

export const ROLE_ACCESS_IS_ANY_LANG_KEY: IRoleAccessIsAnyLang = {
	role_access_is_any: langObj
}
